import React, { Suspense } from "react";
import {
  Col,
  Dialog,
  Gap,
  InputField,
  Row,
} from "../../../ppui";

import { Snackbar } from "../../../ppui/snackbar";
import ErrorBoundary from "../../../utils/error-boundary";
import useOrganisationOwnershipService from "./use-ownership-service";

import { OWNERSHIP_FORM_FIELDS } from "./ownership-constant";
import OwnershipList from "./ownership-list";

function StatutoryEpf() {
  const {
    handleSubmitFn,
    getInputFieldPropsFn,
    organisationBanking,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    resource,
  } = useOrganisationOwnershipService();

  return (
    <>




    

     

      <ErrorBoundary
        fallback={<p>Something went wrong in fetching Owener list...</p>}
      >
        <Suspense fallback={<p>Loading Owener list...</p>}>
          <OwnershipList
          getInputFieldPropsFn={getInputFieldPropsFn}
            resource={resource}
            handleResetForm={handleResetForm}
            setOpen={setOpen}
            handleSubmitFn={handleSubmitFn}
handleClickOpen={handleClickOpen}
          />
        </Suspense>
      </ErrorBoundary>

      <Gap height={50} />

      {/* Modal */}
      <Dialog
        title={`${organisationBanking?.id ? "Update" : "Create New"}  Ownership`}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        loading={createUpdateLoading}
        buttonName={!organisationBanking?.id ? "Save" : "Update"}
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.name.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.phone.name)} 
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.email.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.designation.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.identity_no.name)}
            />
          </Col>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(OWNERSHIP_FORM_FIELDS.pan.name)}
            />
          </Col>

        

        
        </Row>
      </Dialog>

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default StatutoryEpf;
